<template>
  <div>
    <ul class="px-4 py-2 space-y-2">
      <li>
        <input
          v-model="selectedFilter"
          value="day"
          type="radio"
          class="focus:ring-0 mr-3 rounded-full focus:bg-blue-200 checked:border-blue-300 checked:bg-blue-200 text-blue-400 border-gray-300 w-6 h-6"
        />
        <label>is in the last</label>
      </li>

      <li v-if="selectedFilter == 'day'">
        <input
          v-model="day"
          type="number"
          min="0"
          class="appearance-none w-3/12 ml-8 rounded-lg mb-6 focus:outline-none cursor-pointer"
        />

        <select
          v-model="month"
          class="w-7/12 rounded-lg mb-6 focus:outline-none cursor-pointer"
        >
          <option class="text-sm" value="january">January</option>
          <option class="text-sm" value="february">February</option>
          <option class="text-sm" value="march">March</option>
          <option class="text-sm" value="april">April</option>
          <option class="text-sm" value="may">May</option>
          <option class="text-sm" value="june">June</option>
          <option class="text-sm" value="july">July</option>
          <option class="text-sm" value="august">August</option>
          <option class="text-sm" value="setember">Setember</option>
          <option class="text-sm" value="october">October</option>
          <option class="text-sm" value="november">November</option>
          <option class="text-sm" value="decembr">December</option>
        </select>
      </li>

      <li>
        <input
          v-model="selectedFilter"
          value="month"
          type="radio"
          class="focus:ring-0 mr-3 rounded-full focus:bg-blue-200 checked:border-blue-300 checked:bg-blue-200 text-blue-400 border-gray-300 w-6 h-6"
        />
        <label>is in the month of</label>
      </li>

      <li v-if="selectedFilter == 'month'">
        <select
          v-model="month"
          class="ml-8 w-10/12 rounded-lg mb-6 focus:outline-none cursor-pointer"
        >
          <option class="text-sm" value="january">January</option>
          <option class="text-sm" value="february">February</option>
          <option class="text-sm" value="march">March</option>
          <option class="text-sm" value="april">April</option>
          <option class="text-sm" value="may">May</option>
          <option class="text-sm" value="june">June</option>
          <option class="text-sm" value="july">July</option>
          <option class="text-sm" value="august">August</option>
          <option class="text-sm" value="setember">Setember</option>
          <option class="text-sm" value="october">October</option>
          <option class="text-sm" value="november">November</option>
          <option class="text-sm" value="decembr">December</option>
        </select>
      </li>

      <li>
        <input
          v-model="selectedFilter"
          value="year"
          type="radio"
          class="focus:ring-0 mr-3 rounded-full focus:bg-blue-200 checked:border-blue-300 checked:bg-blue-200 text-blue-400 border-gray-300 w-6 h-6"
        />
        <label>is in the year of</label><br />
      </li>

      <li v-if="selectedFilter == 'year'">
        <select
          v-model="year"
          class="ml-8 w-10/12 rounded-lg mb-6 focus:outline-none cursor-pointer"
        >
          <option class="text-sm" value="2019">2019</option>
          <option class="text-sm" value="2020">2020</option>
          <option class="text-sm" value="2021">2021</option>
        </select>
      </li>

      <li>
        <input
          v-model="selectedFilter"
          value="range"
          type="radio"
          class="focus:ring-0 mr-3 rounded-full focus:bg-blue-200 checked:border-blue-300 checked:bg-blue-200 text-blue-400 border-gray-300 w-6 h-6"
        />
        <label>is between</label>
      </li>

      <li v-if="selectedFilter == 'range'">
        <div class="ml-8">
          <h2 class="w-full font-semibold text-sm mb-2">From</h2>
          <DatePickerInput @dateChanged="onDateFromChange" mode="date" />
        </div>
        <div class="ml-8">
          <h2 class=" font-semibold text-sm mb-2">To</h2>
          <DatePickerInput @dateChanged="onDateToChange" mode="date" />
        </div>
      </li>
    </ul>

    <footer class="bg-platinumMild px-4 py-3">
      <button
        @click="applyFilters"
        type="button"
        class="apply-button"
        dusk="apply-filters-button"
      >
        Apply Filters
      </button>
    </footer>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatePickerInput from "@/components/scheduler/Common/DatePickerInput";

var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export default {
  name: 'DateRangeFilter',

  components: {
    DatePickerInput
  },

  data: () => ({
    selectedFilter: null,
    day: "1",
    month: "january",
    year: "2021",
    from: null,
    to: null,
  }),

  methods: {
    applyFilters: function() {
      this.$emit('change', {
        filter: this.selectedFilter,
        value: 
          this.selectedFilter === 'day' ?
            `${this[this.selectedFilter]}-${this.month}`:
            (
              this.selectedFilter === 'range' ?
                `${this.from},${this.to}`:
                this[this.selectedFilter]
            )
      });
    },

    onDateFromChange: function(date) {
      this.from = dayjs(date).format('YYYY/MM/DD');
    },

    onDateToChange: function(date) {
      this.to = dayjs(date).format('YYYY/MM/DD');
    }
  }
}
</script>

<style lang="scss" scoped>
  .apply-button {
    @apply w-full text-yank bg-white border border-platinum transition duration-300 ease-in-out rounded py-2 px-3 font-semibold text-sm hover:border-platinum active:bg-yank active:text-white active:border-yank focus:bg-yank focus:text-white focus:border-yank focus:outline-none;

    &:hover {
      box-shadow: 0 2px 11px rgba(55,54,77,0.08);
    }
  }
</style>